export default __webpack_public_path__ + "static/media/kitchen2.1bd90ed3.webp";